module.exports = __webpack_public_path__ + "static/media/flowertomatoes1.eef16d0f.webp";